import React from "react";
import { NewsletterProps } from "./Newsletter.types";
import {
  StyledWrapper,
  StyledLeftWrapper,
  StyledHeading,
  StyledDescription,
  StyledDesktopImageWrapper,
  StyledLaptopImageWrapper,
  StyledMobileImageWrapper,
} from "./Newsletter.styles";
import { useNewsletterData } from "@components/molecules/Newsletter/Newsletter.hooks";
import { parseData } from "@components/molecules/Newsletter/Newsletter.utils";
import { useI18next } from "gatsby-plugin-react-i18next";
import { StaticImage } from "gatsby-plugin-image";
import Form from "./Form";
import { useNewsletterContext } from "./Newsletter.context";
import { devices } from "@theme/devices";

const Newsletter: React.FC<NewsletterProps> = (props) => {
  const { strapiShared } = useNewsletterData();
  const { height, setHeight } = useNewsletterContext();
  const { language } = useI18next();
  const { heading, description } = parseData(strapiShared, language);
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!ref.current) return;

    const handleResize = () => {
      if (window.innerWidth < devices.phone.max) return;

      setHeight(ref.current.clientHeight);
    };
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [ref, setHeight]);

  return (
    <StyledWrapper {...props} ref={ref} $height={height}>
      <StyledLeftWrapper>
        <StyledHeading
          dangerouslySetInnerHTML={{
            __html: heading,
          }}
        />
        <StyledDescription dangerouslySetInnerHTML={{ __html: description }} />
      </StyledLeftWrapper>

      <Form />

      <StyledDesktopImageWrapper>
        <StaticImage
          src="./assets/desktop-bg.jpg"
          alt=""
          quality={100}
          aria-hidden
        />
      </StyledDesktopImageWrapper>
      <StyledLaptopImageWrapper>
        <StaticImage
          src="./assets/laptop-bg.jpg"
          alt=""
          quality={100}
          aria-hidden
        />
      </StyledLaptopImageWrapper>
      <StyledMobileImageWrapper>
        <StaticImage
          src="./assets/mobile-bg.jpg"
          alt=""
          quality={100}
          aria-hidden
        />
      </StyledMobileImageWrapper>
    </StyledWrapper>
  );
};

export default Newsletter;
